import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { buyReward } from "../rewards/rewardsApi";

interface BuyRewardRequest {
  readonly id: string;
  readonly name: string;
}

export const useBuyReward = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const buyRewardMutation = useMutation<void, unknown, BuyRewardRequest>({
    mutationFn: (reward) => buyReward(reward.id),
    onSuccess: async (_data, reward) => {
      enqueueSnackbar(`Nagroda ${reward.name} została kupiona`, { variant: "success" });
      await queryClient.setQueryData(["rewards", reward.id], reward);
      await queryClient.invalidateQueries({ queryKey: ["rewards"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się kupić nagrody. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return {
    buyReward: (reward: BuyRewardRequest) => buyRewardMutation.mutateAsync(reward),
  };
};
